module.exports = __webpack_public_path__ + "static/img/final.3bb08e3.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/final.svg
// module id = 75
// module chunks = 0